module.exports = __webpack_public_path__ + "static/media/cardK.015218ef.svg";